'use client';

import React, { useState } from 'react';

import { Button, TextField } from 'lighthouse';

import { convertPersianToEnglish } from '@/utilities/convertPersianToEnglishNumber';

import { testValidations, VALIDATION_PHONE_NUMBER_IS_INVALID_MESSAGE, validationRegex } from '@/constants/validations';

import { FormValues, phoneNumberStepProps } from './models';

import { requestOtpService } from '@/client/services/core/auth/methods';
import { useFormValidation } from 'hooks/common/useFormValidation';

const safeCall = (callback?: () => void) => {
    try {
        callback?.();
    } catch {
        return;
    }
};

const PhoneNumberStep = ({ onNextStep, onIsUserRegistered, onPhoneNumber, initialPhoneNumber = '', onOtpCodeRequested }: phoneNumberStepProps) => {
    const initialValues: FormValues = { phoneNumber: initialPhoneNumber };
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const validationRules = {
        phoneNumber: (value: string) => (!testValidations(validationRegex.phoneNumberRegex, value) ? VALIDATION_PHONE_NUMBER_IS_INVALID_MESSAGE : '')
    };

    const { values, errors, handleChange, onSubmit } = useFormValidation(initialValues, validationRules);

    const goToValidationCode = (phone: string, isRegistered: boolean) => {
        onIsUserRegistered(isRegistered);
        onPhoneNumber(phone);
        onNextStep('validationCode');
        safeCall(onOtpCodeRequested);
    };

    const handleSubmit = (formData: FormValues) => {
        setIsSubmitLoading(true);
        requestOtpService({
            phoneNumber: convertPersianToEnglish(formData.phoneNumber)
        })
            .then((response) => {
                goToValidationCode(formData.phoneNumber, response.data.content.userStatus !== 'NOT_REGISTERED');
            })
            .catch((error) => {
                setIsSubmitLoading(false);
                if (error.response?.data?.error?.code === 'OTP.ALREADY_GENERATED') {
                    goToValidationCode(formData.phoneNumber, true);
                }
            });
    };

    const handleOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
            onSubmit(handleSubmit)(event);
        }
    };

    return (
        <>
            <TextField
                value={values.phoneNumber}
                onChange={handleChange}
                onKeyUp={handleOnKeyUp}
                color='primary'
                label='شماره‌ی همراه خود را وارد کنید'
                fullWidth
                inputProps={{
                    inputMode: 'numeric',
                    maxLength: 11
                }}
                error={'phoneNumber' in errors}
                helperText={'phoneNumber' in errors ? errors.phoneNumber : ''}
                name='phoneNumber'
            />
            <Button
                className='mt-8'
                variant='contained'
                disabled={!values.phoneNumber}
                loading={isSubmitLoading}
                fullWidth
                size='large'
                onClick={onSubmit(handleSubmit)}>
                دریافت کد تایید
            </Button>
        </>
    );
};

export default PhoneNumberStep;
